import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { Colligate } from "../types";

export const DELETE_QUERY = print(gql`
  mutation DeleteCategoryConversion($deleteCategoryConversionId: Int!) {
    deleteCategoryConversion(id: $deleteCategoryConversionId) {
      id
      colligate {
        id
        databaseName
        description
        active
        partnerVisibleName
        createdAt
        updatedAt
      }
      idColligate
      databaseName
      idCourseType
      idBranch
      categorySlug
      createdAt
      updatedAt
    }
  }
`);

export interface DeleteGql {
  deleteCategoryConversion: {
    id: number;
    colligate: Colligate;
    databaseName: string;
    idColligate: number;
    idCourseType: number;
    idBranch: number;
    categorySlug: string;
    createdAt: Date;
    updatedAt: Date;
  };
}
